import translationcs from './translation-cs.json';
import translationda from './translation-da.json';
import translationde from './translation-de.json';
import translationel from './translation-el.json';
import translationen from './translation-en.json';
import translationes from './translation-es.json';
import translationfi from './translation-fi.json';
import translationfr from './translation-fr.json';
import translationhi from './translation-hi.json';
import translationhr from './translation-hr.json';
import translationhu from './translation-hu.json';
import translationit from './translation-it.json';
import translationja from './translation-ja.json';
import translationlt from './translation-lt.json';
import translationlv from './translation-lv.json';
import translationnb from './translation-nb.json';
import translationnl from './translation-nl.json';
import translationpl from './translation-pl.json';
import translationpt from './translation-pt.json';
import translationro from './translation-ro.json';
import translationsk from './translation-sk.json';
import translationsl from './translation-sl.json';
import translationsv from './translation-sv.json';
import translationtr from './translation-tr.json';
import translationzh from './translation-zh.json';
import translation from './translation.json';

// webpack transforms these JSON imports to resource URLs, so we cast our export accordingly here.
const i18nEndPointMap: Record<string, string> = {
  'translation-cs.json': translationcs as unknown as string,
  'translation-da.json': translationda as unknown as string,
  'translation-de.json': translationde as unknown as string,
  'translation-el.json': translationel as unknown as string,
  'translation-en.json': translationen as unknown as string,
  'translation-es.json': translationes as unknown as string,
  'translation-fi.json': translationfi as unknown as string,
  'translation-fr.json': translationfr as unknown as string,
  'translation-hi.json': translationhi as unknown as string,
  'translation-hr.json': translationhr as unknown as string,
  'translation-hu.json': translationhu as unknown as string,
  'translation-it.json': translationit as unknown as string,
  'translation-ja.json': translationja as unknown as string,
  'translation-lt.json': translationlt as unknown as string,
  'translation-lv.json': translationlv as unknown as string,
  'translation-nb.json': translationnb as unknown as string,
  'translation-nl.json': translationnl as unknown as string,
  'translation-pl.json': translationpl as unknown as string,
  'translation-pt.json': translationpt as unknown as string,
  'translation-ro.json': translationro as unknown as string,
  'translation-sk.json': translationsk as unknown as string,
  'translation-sl.json': translationsl as unknown as string,
  'translation-sv.json': translationsv as unknown as string,
  'translation-tr.json': translationtr as unknown as string,
  'translation-zh.json': translationzh as unknown as string,
  'translation.json': translation as unknown as string
}

export default i18nEndPointMap;
